function fallbackInterpolate(template: string, data: InterpolationData | string[]): string {
  if (Array.isArray(data)) {
    let index = 0
    return template.replace(/%s/g, () => String(data[index++] ?? ''))
  }
  return template.replace(/%\((\w+)\)s/g, (_, key) => String(data[key] ?? ''))
}

/** Fallbacks when the translation catalog fails to load. */
export function installGettextFallbacks(): void {
  window.gettext = (s: string) => s
  window.ngettext = (singular: string, plural?: string, quantity?: number) =>
    quantity === 1 || !plural ? singular : plural
  window.interpolate = fallbackInterpolate
}

function detectLocale(): string {
  return (
    document.documentElement.lang ||
    document.cookie.match(/django_language=(\w+)/)?.[1] ||
    navigator.language.split('-')[0] ||
    'en'
  )
}

/** No-op if window.gettext is already defined (e.g. by the synchronous script tag in head.html). */
export function loadJsi18nScript(): Promise<void> {
  if (typeof window.gettext === 'function') return Promise.resolve()

  return new Promise((resolve, reject) => {
    const locale = detectLocale()
    const script = document.createElement('script')
    script.src = `/jsi18n/?locale=${locale}`
    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`[jsi18n] Failed to load /jsi18n/?locale=${locale}`))
    document.head.appendChild(script)
  })
}
